import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";
import GlobalButton from "../../../../shared/utils/GlobalButton";

export default function IpReasonDialog({ open, onClose, reason }) {
  return (
    <Dialog open={open} onClose={onClose}>
      {/* Dialog Title */}
      <DialogTitle id="rejection-reason-dialog-title">
        <Typography variant="h6" color="error">
          Rejection Reason
        </Typography>
      </DialogTitle>

      {/* Dialog Content */}
      <DialogContent dividers>
        <Typography variant="body1" color="textSecondary">
          {reason || "No reason provided for rejection."}
        </Typography>
      </DialogContent>

      {/* Dialog Actions */}
      <DialogActions>
        <div className="w-30">
          <GlobalButton variant="secondary" size="small" onClick={onClose}>
            {`Close`}
          </GlobalButton>
        </div>
      </DialogActions>
    </Dialog>
  );
}
